export default {
  name: "banners",
  methods: {
      getBannerLinks: function() {
        if (!this.$global.bannerImageLink && !this.$global.bannerObjectLink) {
          return axios({ method: "GET", "url": `${process.env.VUE_APP_DXA_ENDPOINT}/thg/galleries/self?hash=${process.env.VUE_APP_API_HASH}` }).then(result => {
            this.$global.bannerImageLink = result.data.links[3].href;
            this.imageURL = result.data.links[3].href;
            this.$global.bannerObjectLink = result.data.links[2].href;
            this.objectURL = result.data.links[2].href;
            this.getBannerInfo();
          }, error => {
            console.error(error);
          });
        } else {
          this.imageURL = this.$global.bannerImageLink;
          this.objectURL = this.$global.bannerObjectLink;
          this.getBannerInfo();
          return Promise.resolve();
        }
      },
      getBannerInfo: function() {
        if (!this.$global.bannerObjectInfo) {
          return axios({ method: "GET", "url": this.objectURL }).then(result => {
            this.$global.bannerObjectInfo = result.data;
            this.objectInfo = result.data;
            this.objectInfoLoaded = true;
          }, error => {
              console.error(error);
          });
        } else {
          this.objectInfo = this.$global.bannerObjectInfo;
          this.objectInfoLoaded = true;
          return Promise.resolve();
        }
      },
      checkIE: function(container) {
          if (window.matchMedia("(-ms-high-contrast: none), (-ms-high-contrast: active)").matches) {
              document.getElementById(container).style.backgroundImage = `url(${this.imageURL})`;
          }
      }
  }
}